import * as HTMLComponent from "formiojs/components/html/HTML";

export class MyValidationBot extends HTMLComponent.default {

    public static schema(...extend) {
        return HTMLComponent.default.schema({
            label: "Bot validation",
            type: "myvalidationbot",
            key: "myvalidationbot",
            input: false,
            content: "",
        }, ...extend);
    }

    public static get builderInfo() {
        return {
            title: "Validation BOT",
            group: "basic2", // different group name to remove from toolbar
            icon: "fas fa-robot",
            weight: 70,
            schema: {
                label: "Validation BOT",
                type: "myvalidationbot",
                key: "myvalidationbot",
                input: false,
                content: "<p>my content</p>",
                placeholder: "write your content here",
            },
        };
    }

    public elementInfo() {
        const info = super.elementInfo();
        info.type = "input";
        info.changeEvent = "input";
        return info;
    }

}
